import { PageId } from 'constants/pages'

export const enum PageIdWoofzSmd {
  DOG_AGE_SMD = PageId.DOG_AGE_SMD,
  DOG_SEX_SMD = PageId.DOG_SEX_SMD,
  DOG_BREED_SMD = PageId.DOG_BREED_SMD,
  URGE_SMD = PageId.URGE_SMD,
  GOALS_SMD = PageId.GOALS_SMD,
  URGE_1_SMD = PageId.URGE_1_SMD,
  AGRESSIVE_BEHAVIOR_SMD = PageId.AGRESSIVE_BEHAVIOR_SMD,
  TRIGGERS_SMD = PageId.TRIGGERS_SMD,
  URGE_2_SMD = PageId.URGE_2_SMD,
  BEHAVIOR_ISSUES_SMD = PageId.BEHAVIOR_ISSUES_SMD,
  DOG_LISTEN_SMD = PageId.DOG_LISTEN_SMD,
  COMMANDS_SMD = PageId.COMMANDS_SMD,
  EAT_OFF_THE_GROUND_SMD = PageId.EAT_OFF_THE_GROUND_SMD,
  DOG_ACT_SMD = PageId.DOG_ACT_SMD,
  DOG_OFF_AT_HOME_SMD = PageId.DOG_OFF_AT_HOME_SMD,
  PREPARE_SCREEN_SMD = PageId.PREPARE_SCREEN_SMD,
  DOG_PROFILE_SMD = PageId.DOG_PROFILE_SMD,
  HEAR_ABOUT_WOOFZ_SMD = PageId.HEAR_ABOUT_WOOFZ_SMD,
  MANNERS_TO_BUILD_SMD = PageId.MANNERS_TO_BUILD_SMD,
  FEEL_BETTER_SMD = PageId.FEEL_BETTER_SMD,
  PREPARE_FLOW_SMD = PageId.PREPARE_FLOW_SMD,
  EMAIL_SMD = PageId.EMAIL_SMD,
  NEWSLETTER_URGE_SMD = PageId.NEWSLETTER_URGE_SMD,
  SCRATCH_SCREEN_SMD = PageId.SCRATCH_SCREEN_SMD,
  SUBSCRIPTIONS_SMD = PageId.SUBSCRIPTIONS_SMD,
  CHAT_UPSELL_SMD = PageId.CHAT_UPSELL_SMD,
  UPSELL_SMD = PageId.UPSELL_SMD,
  UPSELL_FEEDING_GUIDE_SMD = PageId.UPSELL_FEEDING_GUIDE_SMD,
  UPSELL_EMOTIONAL_SUPPORT_SMD = PageId.UPSELL_EMOTIONAL_SUPPORT_SMD,
  DOWNLOAD_SMD = PageId.DOWNLOAD_SMD,
  ACCOUNT_SMD = PageId.ACCOUNT_SMD,
}
